// extracted by mini-css-extract-plugin
export var bottomItem = "nav-module--bottomItem--16842";
export var bottomLink = "nav-module--bottomLink--632b4";
export var bottomLink__active = "nav-module--bottomLink__active--e124c";
export var bottomNav = "nav-module--bottomNav--8c5a1";
export var footerItem = "nav-module--footerItem--213fd";
export var footerLink = "nav-module--footerLink--edc8b";
export var footerLink__active = "nav-module--footerLink__active--b2e95";
export var footerNav = "nav-module--footerNav--3ef3c";
export var hideMobile = "nav-module--hideMobile--687e5";
export var mainItem = "nav-module--mainItem--ea0a8";
export var mainLink = "nav-module--mainLink--6fe69";
export var mainLink__active = "nav-module--mainLink__active--e6129";
export var mainNav = "nav-module--mainNav--80054";
export var showMobile = "nav-module--showMobile--99978";
export var spin = "nav-module--spin--908de";